import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`;

const readRequest = async (
  offset,
  pageSize,
  searchType,
  searchText,
  orderType,
  orderBy,
  requestType,
) => {
  const { data } = await axios.get(
    `${baseUrl}/request/list?offset=${offset}&pageSize=${pageSize}&searchType=${searchType}&searchText=${searchText}&orderType=${orderType}&orderBy=${orderBy}&requestType=${requestType}`,
  );
  return data;
};

const requestApi = {
  readRequest,
};

export default requestApi;
